import { render, staticRenderFns } from "./kinh-doanh-doi-v2.vue?vue&type=template&id=3bf16432"
import script from "./kinh-doanh-doi-v2.vue?vue&type=script&lang=js"
export * from "./kinh-doanh-doi-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports